// TankView mobile viewport setup. See TSP-142.
// Forces no-zoom on input focus (iOS auto-zooms when focusing an input
// smaller than 16px font, which makes mobile forms feel broken).
// Idempotent - safe to call from each mini app or once globally from App.js.

export function setupMobileViewport() {
  if (typeof document === "undefined") return;
  let vp = document.querySelector('meta[name="viewport"]');
  const content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
  if (vp) {
    vp.content = content;
    return;
  }
  vp = document.createElement("meta");
  vp.name = "viewport";
  vp.content = content;
  document.head.appendChild(vp);
}

export default setupMobileViewport;
